import React, { Fragment, useEffect, useState } from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import {
    DialogContent,
    Grid,
} from "@material-ui/core";
import colorsService from "../../../services/colors.service";
import colorCategoriesService from "../../../services/color-categories.service";

const FormWrapper = ({ children }) => (
    <DialogContent>
        {children}
        {/* <Grid container spacing={2} alignItems={"center"}>
      {children}
    </Grid> */}
    </DialogContent>
);

const schema = Yup.object().shape({
    colorCategories: yupSchema.colorCategories,
});

export default function SelectCategoryModal({ close, data, extra }) {

    const {
        id,
        categories = []
    } = data;

    const errorHandler = useErrorHandler();

    const [colorCategoryList, setColorCategoryList] = useState([]);

    const form = useMemo(
        () => [
            {
                _type: "container",
                name: "col1",
                _wrapper: (props) => <Grid item sm={12} md={12} xs={12} {...props} />,
                form: ({ setFieldValue }) => [
                    {
                        _type: "autocomplete",
                        _empty: undefined,
                        name: "colorCategories",
                        options: colorCategoryList.map(item => ({
                            ...item,
                            key: item.id,
                            value: item.id,
                        })),
                        label: "دسته بندی رنگ ها",
                        disableClearable: true,
                        multiple: true,
                        valueSelector: "value",
                        labelSelector: "name",
                        fast: false,
                    },
                ],
            }
        ],
        [colorCategoryList]
    );

    const initialValues = useMemo(() => {
        const obj = {
            colorCategories: categories.map(item => item.id)
        };
        return obj;
    }, [categories]);

    const handleSubmit = async (_model, { setSubmitting }) => {
        const {
            colorCategories
        } = _model

        let op = await colorsService.setColorToCategories(id, colorCategories)
        const { error } = op;
        setSubmitting(false);
        if (error) return errorHandler(error);

        close(true);
    };

    const getAPI = () => {
        colorCategoriesService.getColorCategories()
            .then(res => {
                setColorCategoryList(res.data)
            })
    }

    useEffect(() => {
        getAPI()
    }, []);

    return (
        <DialogFormBuilder
            {...{
                close,
                title: "دسته بندی رنگ ها",
                data: colorCategoryList.map(item => item.id),
                schema,
                initialValues,
                handleSubmit,
                form,
                formWrapper: FormWrapper,
                submitLabel: "ذخیره",
            }}
        />
    );
}
